import { get, post, patch, put, del, postUpload } from '@/libs/http'
/* ================================ 首页信息相关 ============================ */
export const getSmartMoneyList = (search) => get('/smart-money/list', search)




